export default {
  CryptoBalance: "Крипто Баланс",
  Displayedcurrencies: "Отображаемые валюты",
};
